import Layout from '@/components/layout.vue'
const asynRouter = [
    {
        path: '/',
        name: 'home',
        redirect: '/index',
    },
    {
        path: '/open_with_name',
        name: 'open_with_name',
        component: () => import('@/pages/openWithName.vue')
    },
    {
        path: '/index',
        component: Layout,
        children: [
            {
                path: '/',
                name: 'index',
                component: () => import('@/pages/index/index.vue'),
                meta: { title: '系统首页', nav_name: '首页', isLock: false, contentBackground: 'contentBg' }
            },
        ]
    },
    {
        path: '/reset',
        name: 'reset_login',
        nav_name: '重置密码',
        component: () => import('@/pages/login/reset.vue')
    },
    {
        path: '/dingtalk/callback',
        name: 'dingtalk_callback',
        nav_name: '钉钉二维码登录',
        component: () => import('@/pages/login/dingTalkCallback.vue')
    },
    {
        path: '/sticker',
        component: Layout,
        children: [
            {
                path: 'create',
                name: 'sticker_create',
                component: () => import('@/pages/sticker/create.vue'),
                meta: { title: '生成溯源码', nav_name: '生成溯源码', isLock: false }
            },
            {
                path: 'list',
                name: 'sticker_list',
                component: () => import('@/pages/sticker/list.vue'),
                meta: { title: '溯源码查询', nav_name: '溯源码查询', isLock: false }
            },
            {
                path: 'detail/:id',
                name: 'sticker_detail',
                component: () => import('@/pages/sticker/detail.vue'),
                meta: { title: '溯源码详情', nav_name: '溯源码详情', isLock: false, tagParam: 'id' }
            },
            {
                path: 'status/:id',
                name: 'sticker_status',
                component: () => import('@/pages/sticker/status.vue'),
                meta: { title: '溯源码统计', nav_name: '溯源码统计', isLock: false, tagParam: 'id' }
            },
            {
                path: 'goods_list',
                name: 'goods_list',
                component: () => import('@/pages/goods/list.vue'),
                meta: { title: '设置溯源商品', nav_name: '设置溯源商品', isLock: false }
            },
            {
                path: 'cross_doubt',
                name: 'cross_doubt',
                component: () => import('@/pages/sticker/crossDoubt.vue'),
                meta: { title: '窜货可疑列表', nav_name: '窜货可疑列表', isLock: false }
            }
        ]
    },
    {
        path: '/coupon',
        component: Layout,
        children: [
            {
                path: 'general',
                name: 'coupon_general',
                component: () => import('@/pages/coupon/general.vue'),
                meta: { title: '优惠券列表', nav_name: '优惠券列表', isLock: false }
            },
            {
                path: 'edit/:id',
                name: 'coupon_edit',
                component: () => import('@/pages/coupon/edit.vue'),
                meta: { title: '编辑优惠券', nav_name: '编辑优惠券', isLock: false, tagParam: 'id' }
            },
            {
                path: 'add',
                name: 'coupon_add',
                component: () => import('@/pages/coupon/edit.vue'),
                meta: { title: '添加优惠券', nav_name: '添加优惠券', isLock: false }
            },
            {
                path: 'list',
                name: 'coupon_list',
                component: () => import('@/pages/coupon/list.vue'),
                meta: { title: '兑换列表', nav_name: '兑换列表', isLock: false }
            },
            {
                path: 'shop_list',
                name: 'shop_list',
                component: () => import('@/pages/coupon/shop.vue'),
                meta: { title: '店铺列表', nav_name: '店铺列表', isLock: false }
            }
        ]
    },
    {
        path: '/abnormal_list',
        component: Layout,
        children: [
            {
                path: '/',
                name: 'abnormal_list',
                nav_name: '异常列表',
                component: () => import('@/pages/abnormal/list.vue'),
                meta: { title: '异常列表', nav_name: '异常列表', isLock: false }
            }
        ]
    },
    {
        path: '/feedback',
        component: Layout,
        children: [
            {
                path: '/feedback_list',
                name: 'feedback_list',
                nav_name: '查验用户反馈',
                component: () => import('@/pages/feedback/list.vue'),
                meta: { title: '查验用户反馈', nav_name: '查验用户反馈', isLock: false }
            },
            {
                path: '/he_list',
                name: 'he_list',
                nav_name: '核算用户反馈',
                component: () => import('@/pages/feedback/helist.vue'),
                meta: { title: '核算用户反馈', nav_name: '核算用户反馈', isLock: false }
            }
        ]
    },
    {
        path: '/client_user',
        component: Layout,
        children: [
            {
                path: 'list',
                name: 'client_list',
                nav_name: '用户列表',
                component: () => import('@/pages/client_user/list.vue'),
                meta: { title: '用户列表', nav_name: '用户列表', isLock: false }
            },
            {
                path: 'detail/:ac_id',
                name: 'client_detail',
                nav_name: '用户详情',
                component: () => import('@/pages/client_user/detail.vue'),
                meta: { title: '用户详情', nav_name: '用户详情', isLock: false, tagParam: 'ac_id' }
            }
        ]
    },
    {
        path: '/export',
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'export_index',
                component: () => import('@/pages/export/index.vue'),
                meta: { title: '导出列表', nav_name: '导出列表', isLock: false }
            }
        ]
    },
    {
        path: '/login',
        name: 'login',
        nav_name: '登陆',
        component: () => import('@/pages/login/login.vue')
    },
    {
        path: '/404',
        component: () => import('@/pages/404/404.vue')
    },
    {
        path: '*',
        redirect: '/404'
    },
]

export default asynRouter
